import React from "react";

import { CLAIM_COMPONENT_MAPPER } from "./ComponentMapper";
import type {
  ClaimsComponentMapperType,
  ClaimsComponentRendererProps,
} from "./types";

export const ClaimsComponentRenderer: React.FC<
  ClaimsComponentRendererProps
> = ({ cards, layout, mapper: customMapper }) => {
  const mapperToUse: ClaimsComponentMapperType =
    customMapper || CLAIM_COMPONENT_MAPPER;
  const mapper = mapperToUse[layout] || {};

  if (!cards) {
    return null;
  }

  return (
    <>
      {cards.map((card) => {
        const CardComponent = mapper[card.cardName];

        if (!CardComponent) {
          return null;
        }

        const props = card.data;

        if (props && typeof props === "object") {
          return <CardComponent key={card.cardName} {...props} />;
        }

        return <CardComponent key={card.cardName} data={props} />;
      })}
    </>
  );
};

export default ClaimsComponentRenderer;
